import * as React from "react";
import { RightIcon } from "../../../components/ui/icons";
import { IUserGuide } from "../userGuideTypes";
import { openUserGuideFile } from "../utils";

interface IUserGuideCardsProps {
  userGuides: IUserGuide[];
}

const UserGuideCards = ({ userGuides }: IUserGuideCardsProps) => {
  if (!userGuides.length) {
    return (
      <div className="user-guide-empty-state">
        No help guides are available right now.
      </div>
    );
  }

  return (
    <div className="guides-content">
      {userGuides.map((guide) => (
        <div className="guide-card" key={guide.id}>
          <div>
            <div className="guide-title" title={guide.title}>
              {guide.title}
            </div>
            <div
              className="guide-description"
              title={guide.description || "No description available."}
            >
              {guide.description || "No description available."}
            </div>
          </div>

          <div className="guide-footer">
            <button
              disabled={!guide.fileUrl}
              onClick={() => openUserGuideFile(guide.fileUrl)}
            >
              View Guide <RightIcon />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserGuideCards;
